import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { TwoFactorAuthActivate } from '@components/templates/authentication/twoFactorAuthActivate';

export function TwoFactorAuthActivatePage() {
    const { t } = useTranslation();

    const translations = {
        title: t('two-factor-authentication-component.metatags.title'),
        description: t('two-factor-authentication-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.twoFactorAuthActivate,
        index: false,
    });

    return <TwoFactorAuthActivate />;
}
